module.exports = require("lodash/find");


//////////////////
// WEBPACK FOOTER
// external "lodash/find"
// module id = 40
// module chunks = 0